import { useRef } from "react";
import type { Location } from "react-router-dom";

import { resolveRidesViewRoutesLocation } from "./rides-kanban-switch.utils";

export const useRidesViewSwitchPane = ({
  location,
  paneViewKey,
}: {
  location: Location;
  paneViewKey: string;
}) => {
  const frozenLocationRef = useRef(location);

  return {
    routesLocation: resolveRidesViewRoutesLocation({
      liveLocation: location,
      frozenLocation: frozenLocationRef.current,
      paneViewKey,
    }),
  };
};
